import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppLayout from "@/components/layout/AppLayout";
import InstallPWAPrompt from "@/components/InstallPWAPrompt";
import LoginPage from "@/pages/Login";
import RegisterPage from "@/pages/Register";
import DashboardPage from "@/pages/Dashboard";
import OTsListPage from "@/pages/OTsList";
import OTNewPage from "@/pages/OTNew";
import OTDetailPage from "@/pages/OTDetail";
import OTEditPage from "@/pages/OTEdit";
import OTUploadPage from "@/pages/OTUpload";
import CatalogsPage from "@/pages/Catalogs";
import CostosMaquilaPage from "@/pages/CostosMaquila";
import OTACListPage from "@/pages/OTACList";
import OTACNewPage from "@/pages/OTACNew";
import OTACEditPage from "@/pages/OTACEdit";
import OTACDetailPage from "@/pages/OTACDetail";
import OTACUploadPage from "@/pages/OTACUpload";
import CotizacionesACNewPage from "@/pages/CotizacionesACNew";
import CotizacionesACDetailPage from "@/pages/CotizacionesACDetail";
import CotizacionesACEditPage from "@/pages/CotizacionesACEdit";
import UsersPage from "@/pages/Users";
import NotificationsPage from "@/pages/Notifications";

function RequireAuth() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}

function RequirePerm({ module }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin" && !(user.permissions || []).includes(module)) {
    return <Navigate to="/dashboard" replace />;
  }
  return <Outlet />;
}

function App() {
  return (
    <div className="dark">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route element={<RequireAuth />}>
              <Route element={<AppLayout />}>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route element={<RequirePerm module="dashboard" />}>
                  <Route path="/dashboard" element={<DashboardPage />} />
                </Route>
                <Route element={<RequirePerm module="ots" />}>
                  <Route path="/ots" element={<OTsListPage />} />
                  <Route path="/ots/:id" element={<OTDetailPage />} />
                </Route>
                <Route element={<RequirePerm module="ot_create" />}>
                  <Route path="/ots/new" element={<OTNewPage />} />
                </Route>
                <Route element={<RequirePerm module="ot_upload" />}>
                  <Route path="/ots/upload" element={<OTUploadPage />} />
                </Route>
                <Route element={<RequirePerm module="ot_edit" />}>
                  <Route path="/ots/:id/edit" element={<OTEditPage />} />
                </Route>
                <Route element={<RequirePerm module="catalogs" />}>
                  <Route path="/catalogs" element={<CatalogsPage />} />
                </Route>
                <Route element={<RequirePerm module="costos_view" />}>
                  <Route path="/costos" element={<CostosMaquilaPage />} />
                </Route>
                <Route element={<RequirePerm module="otac_view" />}>
                  <Route path="/ots-comercial" element={<OTACListPage />} />
                  <Route path="/ots-comercial/new" element={<OTACNewPage />} />
                  <Route path="/ots-comercial/upload" element={<OTACUploadPage />} />
                  <Route path="/ots-comercial/cotizaciones/new" element={<CotizacionesACNewPage />} />
                  <Route path="/ots-comercial/cotizaciones/:cotId" element={<CotizacionesACDetailPage />} />
                  <Route path="/ots-comercial/cotizaciones/:cotId/edit" element={<CotizacionesACEditPage />} />
                  <Route path="/ots-comercial/:id" element={<OTACDetailPage />} />
                  <Route path="/ots-comercial/:id/edit" element={<OTACEditPage />} />
                </Route>
                <Route element={<RequirePerm module="users" />}>
                  <Route path="/users" element={<UsersPage />} />
                  <Route path="/notifications" element={<NotificationsPage />} />
                </Route>
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" richColors position="top-right" />
        <InstallPWAPrompt />
      </AuthProvider>
    </div>
  );
}

export default App;
